// 此API只使用数动云医

const API_URL = {

    //报告详情
    queryUserPhysicalRecordDetail: "userPhysicalRecord/queryUserPhysicalRecordDetail",
    //请求历史详情
    queryUserPhysicalBodyHistory: "/userPhysicalRecord/queryUserPhysicalBodyHistory",
    //请求ssp报告详情
    sspRecordDetail:"api/examination/record/queryUserPhysicalRecordDetail",
    //请求体检报告列表
    queryRecordsByConditions:"api/examination/record/queryRecordsByConditions",
    //请求体检计划列表
    planAll:"api/examination/plan/all"


}
export default API_URL


